import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  title?: string;
  description?: string;
  image?: {
    _: string;
    md?: string;
    imageAlt?: string;
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'title',
    label: 'title',
    type: types.TEXT,
  },
  {
    key: 'description',
    label: 'description',
    type: types.TEXT,
  },
  {
    key: 'image',
    label: 'image',
    type: types.OBJECT,
    children: [
      {
        key: '_',
        label: 'Mobile (or Base)',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'md',
        label: 'Desktop',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT,
      },
    ],
  },
];

const defaultProps: Props = {
  title: 'FF App',
  description: `Requesting and scheduling service, receiving service alerts, and contacting FF Roadside Assistance is only a touch away. 
  Stay in contact with the FF Service Support team at any time, any day through your FF Intelligent App.`,
  image: {
    _: 'https://genesis-cdn.ff.com/press_room/2023-08/0829PR/--2023-08-29-17.28.09-default.jpg',
    md: 'https://genesis-cdn.ff.com/press_room/2023-08/0829PR/--2023-08-29-17.28.09-default.jpg',
    imageAlt: 'Image Alt',
  },
};

export default {
  title: 'Title Image',
  id: 'TitleImage',
  propsSchema,
  defaultProps,
}
